<template>
  <article class="ut-mb-20">
    <h2>Performance</h2>

    <performance-agency-group-stats v-if="groupStats.length != 0 && hasAllGroupStats"
                                    :groupStats="groupStats" />

    <!--- Table -->
    <section>
      <div class="performance-overview-container">
        <performance-overview>

          <!-- Group Overview Row -->
          <performance-overview-row v-for="agency in filteredAgencyStats"
          :rowName="formatAgencyName(agency.agency.agencyName)"
          v-bind:key="agency.id"
          v-bind:rowIcon="'pin'"
          :rowClass="`group-overview ${agencyStats.length > 1 ? '' : 'ut-hidden'}`"
          :referrals="agency.stats.referrals"
          :listingReferrals="agency.stats.goToMarkets"
          :yourListings="agency.stats.listings"
          :wonListings="agency.stats.wonListingRate | percentage"
          :firstAttempt="agency.stats.medianMinutesFirstAttempt | formatDuration"
          :contact="agency.stats.medianMinutesFirstContact | formatDuration"
          :SuccessfulContact="agency.stats.successfulContactRate | percentage">

            <!-- Default Row - Agent Stats -->
            <performance-overview-row-agent
              v-for="agent in agentStatsForAgency(agency.agency)"
              v-bind:key="agent.id"
              @click.native="navigateToLeadsForAgent(agent.agent.key)"
              :rowName="agent.agent.displayName"
              :avatarFilename="agent.agent.imageUrl"
              :referrals="agent.stats.referrals"
              :listingReferrals="agent.stats.goToMarkets"
              :yourListings="agent.stats.listings"
              :wonListings="agent.stats.wonListingRate | percentage"
              :firstAttempt="agent.stats.medianMinutesFirstAttempt | formatDuration"
              :contact="agent.stats.medianMinutesFirstContact | formatDuration"
              :SuccessfulContact="agent.stats.successfulContactRate | percentage" />

          </performance-overview-row>

          <!-- Top Agent in the area Row -->
          <performance-overview-row v-if="showCompetitiveStats"
          :rowName="'top agents'"
          v-bind:rowIcon="'icon-line-chart'"
          :rowClass="'top-agents'"
          :wonListings="sanitizedCompetitiveStats.wonListingRate | percentage"
          :firstAttempt="sanitizedCompetitiveStats.medianMinutesFirstAttempt | formatDuration"
          :contact="sanitizedCompetitiveStats.medianMinutesFirstContact | formatDuration"
          :SuccessfulContact="sanitizedCompetitiveStats.contactOverRate | percentage" />

        </performance-overview>
        <div class="no-info" v-if="agencyStats.length == 0">
            There are no referrals for this period.
        </div>
      </div>
    </section>
  </article>
</template>

<script>
import PerformanceAgencyGroupStats from '@/components/PerformanceAgencyGroupStats.vue';
import PerformanceOverview from '@/components/Tables/PerformanceOverview.vue';
import PerformanceOverviewRow from '@/components/Tables/PerformanceOverviewRow.vue';
import PerformanceOverviewRowAgent from '@/components/Tables/PerformanceOverviewRowAgent.vue';

export default {
  name: 'PerformanceAgentsSection',
  components: {
    PerformanceAgencyGroupStats,
    PerformanceOverview,
    PerformanceOverviewRow,
    PerformanceOverviewRowAgent,
  },
  props: {
    agentStats: {
      required: true,
      type: Array,
    },
    agencyStats: {
      required: true,
      type: Array,
    },
    groupStats: {
      required: true,
      default: null,
    },
    competitiveStats: {
      required: true,
      default: null
    },
    isManager: Boolean,
    isPrincipal: Boolean,
  },
  computed: {
    hasAllGroupStats() {
      return !((!this.groupStats.wonListingRate && !this.groupStats.medianMinutesFirstAttempt
      && !this.groupStats.medianMinutesFirstContact && !this.groupStats.successfulContactRate));
    },
    filteredAgencyStats() {
      // Filters from the entire list
      // only stats for agencies that have at least ONE of the stats to display
      return this.agencyStats.filter(a => this.hasDisplayableStatsValue(a.stats));
    },
    showCompetitiveStats() {
      return this.agencyStats && this.agencyStats.length;
    },
    sanitizedCompetitiveStats() {
      return this.competitiveStats || {};
    }
  },
  data() {
    return {

    };
  },
  methods: {
    formatAgencyName(agencyName) {
      if (agencyName && agencyName.length > 0) {
        // Agency names are formatted "{{agency name}} - {{agency suburb}}"
        // We want to display only agency name
        return agencyName.split(' - ').pop().trim();
      }
      return agencyName;
    },
    agentStatsForAgency(agency) {
      // Filters from the entire list
      // only stats for agents that belong to the agency
      // and agents that have at least ONE of the stats to display
      return this.agentStats
        .filter(a => a.agency.id == agency.id
          && a.statsTypeId === 1
          && this.hasDisplayableStatsValue(a.stats));
    },
    hasDisplayableStatsValue(stats) {
      return stats.referrals > 0
        || stats.attempted > 0
        || stats.contacted > 0
        || stats.goToMarkets > 0
        || stats.listings > 0
        || stats.wonListingRate > 0
        || stats.medianMinutesFirstAttempt != null
        || stats.medianMinutesFirstContact != null
        || stats.successfulContactRate != null;
    },
    navigateToLeadsForAgent(agentKey) {
      if (this.isPrincipal) {
        const ak = this.$route.params.ak || this.ak;
        const uk = this.$route.params.uk || this.uk;
        this.$router.push({
          path: `${ak ? `/${ak}` : ''}/leads/${uk}`,
          query: { agent: agentKey },
        });
      }
    },
  }
};
</script>

<style scoped lang="scss">
  h2 {
    opacity: 0.9;
    color: #233A3A;
    font-size: 20px;
    font-weight: 600;
    letter-spacing: -0.3px;
    line-height: 28px;
    margin: 20px auto;
  }
</style>
